module.exports = new __parcel__URL__("unknown-error.af4eba12.svg").toString();